import React, { FunctionComponent } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { isEditorActive, Text } from '@sitecore-jss/sitecore-jss-react';
import CustomExternalAnchor from '../../../@shared/customExternalAnchor';
import { SecondaryLinkWithBoldModel } from '../../models/navigationItem.model';
import { isInternalUrl } from '../../../../utils/link.utils';

const SecondaryLinkWithBold: FunctionComponent<{ model: SecondaryLinkWithBoldModel; onClick?: () => void }> = ({ model, onClick }) => {
  const wrapperClassName = 'navigation-link navigation-link--secondary-with-bold';
  const nonBoldTextClassName = 'navigation-link__non-bold-text';
  const dividerClassName = 'navigation-link__divider';
  const boldTextClassName = 'navigation-link__bold-text';

  if (isEditorActive()) {
    return (
      <div className={wrapperClassName}>
        <CustomExternalAnchor field={model.link} className={nonBoldTextClassName} />{' '}
        <Text field={model.divider} className={dividerClassName} tag="span" />{' '}
        <Text field={model.boldText} className={boldTextClassName} tag="span" />
      </div>
    );
  } else {
    if (isInternalUrl(model.linkUrl)) {
      return (
        <RouterLink to={model.linkUrl} {...model.linkOtherProps} className={wrapperClassName} onClick={onClick}>
          <span className={nonBoldTextClassName}>{model.linkText}</span>{' '}
          <Text field={model.divider} className={dividerClassName} tag="span" />{' '}
          <Text field={model.boldText} className={boldTextClassName} tag="span" />
        </RouterLink>
      );
    } else {
      return (
        <CustomExternalAnchor field={model.link} className={wrapperClassName}>
          <span className={nonBoldTextClassName}>{model.linkText}</span>{' '}
          <Text field={model.divider} className={dividerClassName} tag="span" />{' '}
          <Text field={model.boldText} className={boldTextClassName} tag="span" />
        </CustomExternalAnchor>
      );
    }
  }
};

export default SecondaryLinkWithBold;
